// src/components/CloudflareInsights.tsx
"use client";

import Script from "next/script";
import { useEffect, useState } from "react";
import { runAfterConsent } from "@/utils/analyticsUtils";

const CloudflareInsights = () => {
  const [loadInsights, setLoadInsights] = useState(false);

  useEffect(() => {
    runAfterConsent(() => setLoadInsights(true));
  }, []);

  if (!loadInsights) return null;

  return (
    <Script
      src="https://static.cloudflareinsights.com/beacon.min.js"
      strategy="lazyOnload"
      onLoad={() => console.log("Cloudflare Insights script loaded.")}
      onError={(e) =>
        console.error("Error loading Cloudflare Insights script:", e)
      }
    />
  );
};

export default CloudflareInsights;
